import Vue from 'vue'
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import {
  ADD_AD, ADD_ORDER_COMMENT, CANCEL_CLAIM, CANCEL_ORDER, DELETE_ORDER_COMMENT,
  EDIT_ORDER,
  FINISH_ORDER,
  LOAD_ADS_LIST,
  LOAD_DEALS_LIST,
  LOAD_ORDERS_LIST, OPEN_CLAIM,
  RESET_ORDERS, RESTART_FINISH_ERROR_ORDERS, SWITCH_NOTE
} from "../const/orders";

export default {
  namespaced: true,
  state: {
    orders: {
      pagination: {},
      orders: [],
    },
    ads: [],
    deals: [],
    dialog: {
      id: null,
      messages: []
    },
    statusesLocales: {
      new: 'Новая',
      canceled: 'Отменена',
      invoice_added: 'Инвойс создан',
      requisite_added: 'Реквизиты получены',
      requisite_sent: 'Реквизиты отправлены',
      paid: 'Помечена оплаченной',
      claim: 'Претензия',
      wait_finish: 'Завершение',
      wait_finish_validation: 'Завершена (сверка балансов)',
      wait_cancel: 'Отмена',
      wait_refuse: 'Отказ',
      wait_change_amount: 'Изменение суммы',
      finished: 'Завершена',
      refused: 'Отказано',
      finish_error: 'Ошибка завершения',
      cancel_error: 'Ошибка отмены',
      refuse_error: 'Ошибка отказа',
    },
    finishReasons: {
      'duplicate': { description: 'Дубликат', availableOption: true },
      'timeout': { description: 'Просрочка заявки', availableOption: true },
      'ticket': { description: 'Решение из чата', availableOption: true },
      'compensation': { description: 'Компенсация по заявке', availableOption: true },
      'finish_error': { description: 'Ошибка завершения', availableOption: true },
      'deal': { description: 'Закрытие сделки', availableOption: false },
      'claim': { description: 'Закрытие претензии', availableOption: false },
    },
  },
  getters: {
    orders: state => state.orders,
    ads: state => state.ads,
    deals: state => state.deals,
    statusesLocales: state => state.statusesLocales,
    finishReasons: state => state.finishReasons,
  },
  actions: {
    [LOAD_ORDERS_LIST]: async ({ dispatch }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_ORDERS_LIST,
        namespace: 'orders',
        params,
      }, { root: true });
    },
    [EDIT_ORDER]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_ORDER,
        namespace: 'orders',
        body: { data },
        replace: { id },
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [LOAD_ADS_LIST]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_ADS_LIST,
        namespace: 'orders',
      }, { root: true });
    },
    [ADD_AD]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_POST, {
        method: ADD_AD,
        namespace: 'orders',
        replace: { id },
        body: data,
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [LOAD_DEALS_LIST]: async ({ dispatch }, { order_id }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_DEALS_LIST,
        namespace: 'orders',
        replace: { id: order_id },
      }, { root: true });
    },
    [FINISH_ORDER]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_PUT, {
        method: FINISH_ORDER,
        namespace: 'orders',
        replace: { id },
        body: data,
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [OPEN_CLAIM]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_POST, {
        method: OPEN_CLAIM,
        namespace: 'orders',
        replace: { id },
        body: data,
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [CANCEL_CLAIM]: async ({ dispatch }, { id }) => {
      const request = await dispatch(HTTP_DELETE, {
        method: CANCEL_CLAIM,
        namespace: 'orders',
        replace: { id },
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [CANCEL_ORDER]: async ({ dispatch }, { id }) => {
      const request = await dispatch(HTTP_PUT, {
        method: CANCEL_ORDER,
        namespace: 'orders',
        replace: { id },
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [SWITCH_NOTE]: async ({ dispatch }, { id, type }) => {
      const request = await dispatch(HTTP_PUT, {
        method: SWITCH_NOTE,
        namespace: 'orders',
        replace: { id, type },
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [ADD_ORDER_COMMENT]: async ({ dispatch }, { id, text }) => {
      const request = await dispatch(HTTP_POST, {
        method: ADD_ORDER_COMMENT,
        namespace: 'orders',
        replace: { id },
        body: { text },
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [DELETE_ORDER_COMMENT]: async ({ dispatch }, { comment_id }) => {
      const request = await dispatch(HTTP_DELETE, {
        method: ADD_ORDER_COMMENT,
        namespace: 'orders',
        body: { comment_id },
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [RESTART_FINISH_ERROR_ORDERS]: async ({ dispatch }, days) => {
      const request = await dispatch(HTTP_POST, {
        method: RESTART_FINISH_ERROR_ORDERS,
        namespace: 'orders',
        body: { days },
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
  },
  mutations: {
    [LOAD_ORDERS_LIST]: (state, { data }) => {
      Vue.set(state.orders, 'orders', data.orders);
      Vue.set(state.orders, 'pagination', data.pagination);
    },
    [LOAD_ADS_LIST]: (state, { data }) => {
      Vue.set(state, 'ads', data.ads);
    },
    [LOAD_DEALS_LIST]: (state, { data }) => {
      Vue.set(state, 'deals', data.deals);
    },
    [RESET_ORDERS]: (state) => {
      Vue.set(state, 'orders', { pagination: {}, orders: []});
    }
  },
};
